// assets/uc-cart-entries.js
(() => {
  const VALUE_SEL = ".uc-cart-entries__value";

  const parseIntFromText = (t) => {
    const n = String(t || "").replace(/[^\d]/g, "");
    return n ? parseInt(n, 10) : 0;
  };

  const formatInt = (n) =>
    new Intl.NumberFormat("en-US").format(Math.max(0, Math.round(n)));

  const animateNumber = (el, from, to, ms = 550, done) => {
    el.dataset.ucAnimating = "1";
    el.classList.remove("uc-bump");
    void el.offsetWidth; // reflow to restart animation
    el.classList.add("uc-bump");
    const start = performance.now();
    const diff = to - from;

    const tick = (now) => {
      const p = Math.min(1, (now - start) / ms);
      const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
      el.textContent = formatInt(from + diff * eased);

      if (p < 1) requestAnimationFrame(tick);
      else {
        el.textContent = formatInt(to);
        delete el.dataset.ucAnimating;
        if (typeof done === "function") done();
      }
    };

    requestAnimationFrame(tick);
  };

  // Keep last known value even if Dawn swaps DOM
  let lastValue = null;

  // Track current binding
  let boundEl = null;
  let valueObserver = null;

  const bindToValueEl = (el) => {
    if (!el || el === boundEl) return;

    if (valueObserver) valueObserver.disconnect();
    boundEl = el;

    const current = parseIntFromText(el.textContent);

    // First time on page: animate 0 -> current (optional)
    if (lastValue === null) {
      lastValue = current;
      animateNumber(el, 0, current);
    } else if (current !== lastValue) {
      // Re-bind after DOM replacement: animate last -> current
      const from = lastValue;
      lastValue = current;
      animateNumber(el, from, current);
    }

    valueObserver = new MutationObserver(() => {
      // IMPORTANT: ignore our own animation updates
      if (el.dataset.ucAnimating === "1") return;

      const next = parseIntFromText(el.textContent);
      if (next === lastValue) return;

      const from = lastValue ?? 0;

      // Disconnect during animation so we don't loop
      valueObserver.disconnect();

      animateNumber(el, from, next, 550, () => {
        lastValue = next;
        // Reconnect after animation completes
        valueObserver.observe(el, { childList: true, characterData: true, subtree: true });
      });
    });

    valueObserver.observe(el, { childList: true, characterData: true, subtree: true });
  };

  // Observe only the cart area (NOT the entire document)
  const getRoot = () =>
    document.querySelector("#MainContent") ||
    document.querySelector("main") ||
    document.body;

  const rootObserver = new MutationObserver(() => {
    const el = document.querySelector(VALUE_SEL);
    if (el) bindToValueEl(el);
  });

  const boot = () => {
    const root = getRoot();
    rootObserver.observe(root, { childList: true, subtree: true });

    const el = document.querySelector(VALUE_SEL);
    if (el) bindToValueEl(el);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Handles bfcache / back button cases
  window.addEventListener("pageshow", () => {
    const el = document.querySelector(VALUE_SEL);
    if (el) bindToValueEl(el);
  });
})();